import Vue from 'vue';
import ApiClient from '@/libs/api_client';

export default {
  strict: true,
  namespaced: true,
  state: {
    places: [
      {
        id: null,
        name: '',
        buildings: [
          {
            id: null,
            name: '',
            floors: [
              {
                id: null,
                name: '',
              },
            ],
          },
        ],
      },
    ],
    destinations: [],
    popularitySpots: [],
  },
  getters: {
    placeAll: (state) => state.places,
    placeFind: (state) => (placeId) => state.places.find((place) => place.id === placeId),
    buildingAll: (state, getters) => getters.placeAll.map((place) => place.buildings).flat(),
    buildingWhere: (state, getters) => (placeId) => getters.placeFind(placeId).buildings,
    buildingFind: (state, getters) => (buildingId) => getters.buildingAll.find((building) => building.id === buildingId),
    buildingFindByFloor: (state, getters) => (floorId) => getters.buildingAll.find(
      (building) => building.floors.map((floor) => floor.id).indexOf(floorId) >= 0,
    ),
    floorAll: (state, getters) => getters.buildingAll.map((building) => building.floors).flat(),
    floorWhere: (state, getters) => (buildingId) => getters.buildingFind(buildingId).floors,
    floorFind: (state, getters) => (floorId) => getters.floorAll.find((floor) => floor.id === floorId),
    spotAll: (state) => state.destinations.filter((spot) => spot.type.indexOf('Spot') === 0 && spot.type.indexOf('VirtualSpot') < 0),
    virtualSpotAll: (state) => state.destinations.filter((spot) => spot.type.indexOf('VirtualSpot') >= 0),
    personAll: (state) => state.destinations.filter((thing) => thing.user != null),
    itemAll: (state) => state.destinations.filter((thing) => thing.item != null),
    personsGroupByPosition: (state, getters) => (floorId) => {
      const persons = getters.personAll;
      const groupingPersons = persons.reduce((groups, person) => {
        const thingPosition = person.thingPositions.find((position) => position.floor.id === floorId);
        if (thingPosition) {
          const x = thingPosition.positionX;
          const y = thingPosition.positionY;
          const key = `${x}-${y}`;

          (groups[key] = groups[key] || []).push(person);
        }

        return groups;
      }, {});

      return groupingPersons;
    },
    buildingAndFloorNameByFloorId: (state, getters) => (floorId) => {
      const floor = getters.floorFind(floorId);
      const building = getters.buildingFindByFloor(floorId);
      return `${building.name} ${floor.name}`;
    },
  },
  mutations: {
    initializePlaces(state, places) {
      Vue.set(state, 'places', places);
    },
    initializeBuildings(state, { placeId, buildings }) {
      const place = state.places.find((findPlace) => findPlace.id === placeId);
      Vue.set(place, 'buildings', buildings);
    },
    setDestinationSpots(state, destinations) {
      const newDestinations = state.destinations.filter((destination) => destination.type.indexOf('Spot') < 0);

      Vue.set(state, 'destinations', [...newDestinations, ...destinations]);
    },
    setDestinationThings(state, destinations) {
      const newDestinations = state.destinations.filter((destination) => destination.type.indexOf('Thing') < 0);

      Vue.set(state, 'destinations', [...newDestinations, ...destinations]);
    },
    setPopularitySpots(state, popularitySpots) {
      Vue.set(state, 'popularitySpots', popularitySpots);
    },
  },
  actions: {
    async getPlaces(context) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const data = await ApiClient.getPlaces();
        context.commit('initializePlaces', data);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getPlaceBuildings(context, placeId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const buildings = await ApiClient.getPlaceBuildings(placeId);
        context.commit('initializeBuildings', { placeId, buildings });
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async searchPopularitySpots(context, placeId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const params = {
          exclusionTypes:   ['Spot::VirtualSpot', 'Spot::RestroomSpot'],
          searchType:       'Popularity',
        };
        const destinations = await ApiClient.getPlaceDestinations(placeId, params);
        context.commit('setPopularitySpots', destinations);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getFloorSpots(context, floorId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const spots = await ApiClient.getFloorSpots(floorId);
        context.commit('setDestinationSpots', spots);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getFloorSpotsInBackground(context, floorId) {
      const spots = await ApiClient.getFloorSpots(floorId);
      context.commit('setDestinationSpots', spots);
    },
    async getFloorThingExTags(context, floorId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const things = await ApiClient.getFloorThingExTags(floorId);
        context.commit('setDestinationThings', things);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getFloorThingExTagsInBackground(context, floorId) {
      const things = await ApiClient.getFloorThingExTags(floorId);
      context.commit('setDestinationThings', things);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/models/area.js